// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2UJC9","cell":"ColumnAccessor_cell__3L29A","firstCellAccent":"ColumnAccessor_firstCellAccent__14-Q4"};